<template>
  <transition name="slide-fade">
    <div class="toast needLang jmai" v-show="visible">
      <p>{{ message }}</p>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'toast',
  data () {
    return {
      message: '', // 消息文字
      duration: 1500, // 显示时长，毫秒
      closed: false, // 用来判断消息框是否关闭
      timer: null, // 计时器
      visible: false // 是否显示
    }
  },
  mounted () {
    this.startTimer()
  },
  watch: {
    closed (newVal) {
      if (newVal) {
        this.visible = false
        this.destroyElement()
      }
    }
  },
  methods: {
    destroyElement () {
      this.$destroy()
      this.$el.parentNode.removeChild(this.$el)
    },
    startTimer () {
      this.timer = setTimeout(() => {
        if (!this.closed) {
          this.closed = true
          clearTimeout(this.timer)
        }
      }, this.duration)
    }
  }
}
</script>

<style>
.toast {
  position: fixed;
  top: 40%;
  left: 50%;
  /* min-width: 300px; */
  max-width: 100vw;
  /* font-size: 24px; */
  height: 50px;
  line-height: 50px;
  text-align: center;
  padding: 0 20px; 
  font-size: 24px;
  background-color: #5e1813;
  border: 1px solid #f8e1dc;
  color: #f8e1dc;
  /* letter-spacing: 3px; */
  transform: translate(-50%,-50%);
}

.toast p{ 
  padding: 0 50px;
  white-space: nowrap;
}

@media screen and (min-width: 1000px){
    .toast{
      max-width: 750px;
    }    
}
</style>